import Vue from 'vue';
import Vuetify, { VApp, VCard, VContainer, VLayout, VFlex, VContent, VList, VDivider, VListTile, VListTileAction, VBreadcrumbs, VDialog, VAvatar, VBreadcrumbsItem, VIcon, VImg, VHover, VCardTitle, VCardText, VCardActions, VToolbar, VToolbarItems, VSpacer, VBtn, VDialogBottomTransition, VTooltip, VPicker, VMenu, VProgressCircular, VListTileTitle, VBadge, VListTileContent, VListTileAvatar, VListGroup, VExpandTransition, VStepper, VStepperContent, VStepperItems, VStepperStep, VStepperHeader, VListTileSubTitle } from "vuetify/lib";
import 'vuetify/src/stylus/app.styl';
// import Vuetify from 'vuetify'
// Vue.use(Vuetify)
Vue.use(Vuetify, {
  components: {
    VApp: VApp,
    VCard: VCard,
    VContainer: VContainer,
    VLayout: VLayout,
    VFlex: VFlex,
    VContent: VContent,
    VList: VList,
    VDivider: VDivider,
    VListTile: VListTile,
    VListTileAction: VListTileAction,
    VBreadcrumbs: VBreadcrumbs,
    VDialog: VDialog,
    VAvatar: VAvatar,
    VBreadcrumbsItem: VBreadcrumbsItem,
    VIcon: VIcon,
    VImg: VImg,
    VHover: VHover,
    VCardTitle: VCardTitle,
    VCardText: VCardText,
    VCardActions: VCardActions,
    VToolbar: VToolbar,
    VToolbarItems: VToolbarItems,
    VSpacer: VSpacer,
    VBtn: VBtn,
    VDialogBottomTransition: VDialogBottomTransition,
    VTooltip: VTooltip,
    VPicker: VPicker,
    VMenu: VMenu,
    VProgressCircular: VProgressCircular,
    VListTileTitle: VListTileTitle,
    VBadge: VBadge,
    VListTileContent: VListTileContent,
    VListTileAvatar: VListTileAvatar,
    VListGroup: VListGroup,
    VExpandTransition: VExpandTransition,
    VStepper: VStepper,
    VStepperContent: VStepperContent,
    VStepperItems: VStepperItems,
    VStepperStep: VStepperStep,
    VStepperHeader: VStepperHeader,
    VListTileSubTitle: VListTileSubTitle
  }
});